var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTickMark = function SvgTickMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12935",
    transform: "translate(-25.029 18.024)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#0eb948",
    "data-name": "Ellipse 307",
    transform: "translate(25.029 -18.024)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    d: "M67.493 50.03h-.088a3.315 3.315 0 0 1-2.344-1.047l-10.027-10.8a3.1 3.1 0 0 1 .244-4.473 3.346 3.346 0 0 1 4.613.24l7.727 8.322 25.445-24.645a3.336 3.336 0 0 1 4.619 0 3.094 3.094 0 0 1 0 4.477l-27.881 27a3.315 3.315 0 0 1-2.308.926Z",
    "data-name": "Path 2486"
  }))));
};
export default SvgTickMark;